"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SPACING_DECIMALS = exports.SPACING_DECIMALS = 10;